export default "__VITE_ASSET__yaCAl9xS__"